import { useState, useEffect } from "react";
import {
  Box,
  Button,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Categorie } from "../../../apiServices/categories.service";

interface AdminCategoryFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSave: (categoryData: {
    categoriaId?: number;
    nombreEspanol: string;
    nombreIngles: string;
  }) => Promise<void>;
  editingCategory: Categorie | null;
  isSubmitting: boolean;
}

export default function AdminCategoryFormDialog({
  open,
  onClose,
  onSave,
  editingCategory,
  isSubmitting,
}: AdminCategoryFormDialogProps) {
  const [nombreEspanol, setNombreEspanol] = useState("");
  const [nombreIngles, setNombreIngles] = useState("");

  useEffect(() => {
    if (editingCategory) {
      setNombreEspanol(editingCategory.nombreEspanol || "");
      setNombreIngles(editingCategory.nombreIngles || "");
    } else {
      setNombreEspanol("");
      setNombreIngles("");
    }
  }, [editingCategory, open]);

  const handleSaveClick = () => {
    onSave({
      categoriaId: editingCategory?.categoriaId,
      nombreEspanol,
      nombreIngles,
    });
  };

  const isFormValid = nombreEspanol.trim() !== "" && nombreIngles.trim() !== "";

  return (
    <Dialog
      open={open}
      onClose={isSubmitting ? undefined : onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ fontWeight: 600 }}>
        {editingCategory?.categoriaId ? "Editar Categoría" : "Nueva Categoría"}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3, mt: 1 }}>
          <TextField
            autoFocus
            label="Nombre en Español"
            type="text"
            fullWidth
            variant="outlined"
            value={nombreEspanol}
            onChange={(e) => setNombreEspanol(e.target.value)}
            disabled={isSubmitting}
          />
          <TextField
            label="Nombre en Inglés"
            type="text"
            fullWidth
            variant="outlined"
            value={nombreIngles}
            onChange={(e) => setNombreIngles(e.target.value)}
            disabled={isSubmitting}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button
          onClick={onClose}
          color="inherit"
          sx={{ fontWeight: 600 }}
          disabled={isSubmitting}
        >
          Cancelar
        </Button>
        <Button
          onClick={handleSaveClick}
          variant="contained"
          disabled={!isFormValid || isSubmitting}
          sx={{ bgcolor: "primary.main", fontWeight: 600, borderRadius: "8px" }}
        >
          {isSubmitting ? "Guardando..." : "Guardar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
